import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { RecordManagementAddButton } from '../../../record-management-add-button';
import { LabelManagementProvider } from '../../../search-table-action-dialog-lists/context';
import { useLabelAction } from '../../hooks';
import { LabelActionDialog } from '../label-action-dialog';
import type { LabelActionButtonProps as Props } from './types';

export const LabelActionButton = memo(
  ({
    className,
    type,
    currentLabelIds,
    id,
    searchTypeOverride,
    onLabelsSelect,
    selectedLabels,
    disabled,
  }: Props) => {
    const labelAction = useLabelAction({
      type,
      currentLabelIds,
      id,
      searchTypeOverride,
      onLabelsSelect,
      selectedLabels,
    });

    const { currentLabels, icon, handleOpenDialog } = labelAction;

    return (
      <LabelManagementProvider onChangeLabels={() => {}}>
        <Stack
          className={classnames('LabelActionButton', className)}
          onClick={(e) => e.stopPropagation()}
        >
          <RecordManagementAddButton
            disabled={disabled}
            onClick={handleOpenDialog}
            value={currentLabels?.length}
            icon={icon}
          />
        </Stack>
        <LabelActionDialog labelAction={labelAction} type={type} />
      </LabelManagementProvider>
    );
  }
);

LabelActionButton.displayName = 'LabelActionButton';
